/*
 * Public API Surface of app-update
 */

export * from './lib/app-update.service';
export * from './lib/app-update.module';
